import PropTypes from 'prop-types';
import React from 'react';
import findKey from 'lodash/findKey';
import {
  SHOP_TYPE,
} from '../../../main/shops/constants';

const shopType = ({ type }) => (
  <span>
    {findKey(SHOP_TYPE, kind => kind === type)}
  </span>
  );

shopType.propTypes = {
  type: PropTypes.number.isRequired,
};

export default shopType;
